module.exports = __webpack_public_path__ + "img/main-visu-we.fd5cae5f.png";